var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.heraShopLink)?_c('div',[_c('button',[_c('a',{attrs:{"href":_vm.heraShopLink + 'consols.html?cat=236',"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('_web_shop_vouchers', 'SHOP VOUCHERS')))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }